import { socialApi } from './shared';

/** Hand-authored Reddit endpoint copy and examples. */
export const REDDIT = socialApi({
  id: 'reddit',
  name: 'Reddit',
  blurb:
    'Pull posts, comments and subreddit data from Reddit as clean, normalized JSON: search, page, or look up a subreddit with one call. Pay in real dollars, no tokens or rate limits to manage.',
  endpoints: {
    search: {
      description:
        'Search Reddit posts across all subreddits by query, with sort and timeframe. Paginate with the after cursor.',
      input: { query: 'best mechanical keyboard', sort: 'relevance', timeframe: 'month' },
      sample: {
        posts: [
          {
            id: 't3_1abc234',
            title: 'What is the best mechanical keyboard under $150?',
            author: 'keebenjoyer',
            score: 1842,
            numComments: 327,
            url: 'https://www.reddit.com/r/MechanicalKeyboards/comments/1abc234/',
            permalink: '/r/MechanicalKeyboards/comments/1abc234/',
            createdUtc: 1_718_200_000,
            subreddit: 'MechanicalKeyboards',
          },
        ],
        nextCursor: 't3_1abc234',
      },
    },
    'subreddit-posts': {
      description:
        'Posts from a subreddit listing (hot, new, or top), with time windows. Paginate with the after cursor.',
      input: { subreddit: 'MechanicalKeyboards', sort: 'hot' },
      sample: {
        posts: [
          {
            id: 't3_1def567',
            title: 'My first custom build is finally done',
            author: 'soldernoob',
            score: 5412,
            numComments: 218,
            url: 'https://www.reddit.com/r/MechanicalKeyboards/comments/1def567/',
            permalink: '/r/MechanicalKeyboards/comments/1def567/',
            createdUtc: 1_718_180_000,
            subreddit: 'MechanicalKeyboards',
          },
        ],
        nextCursor: 't3_1def567',
      },
    },
    'subreddit-search': {
      description:
        'Search posts within a single subreddit by query, sort and timeframe. Paginate with the cursor field.',
      input: { subreddit: 'MechanicalKeyboards', query: 'silent switches' },
      sample: {
        posts: [
          {
            id: 't3_1ghi890',
            title: 'Quietest silent switches you have tried?',
            author: 'lurkmoar',
            score: 612,
            numComments: 144,
            url: 'https://www.reddit.com/r/MechanicalKeyboards/comments/1ghi890/',
            permalink: '/r/MechanicalKeyboards/comments/1ghi890/',
            createdUtc: 1_718_160_000,
            subreddit: 'MechanicalKeyboards',
            nsfw: false,
          },
        ],
        nextCursor: 't3_1ghi890',
      },
    },
    'post-comments': {
      description:
        'Top-level comments on a Reddit post by URL: author, body, score and timestamp. Paginate with the cursor field.',
      input: { url: 'https://www.reddit.com/r/MechanicalKeyboards/comments/1abc234/' },
      sample: {
        comments: [
          {
            id: 't1_klm123',
            author: 'switchdoctor',
            body: 'Look at the Keychron V-series, great value out of the box.',
            url: 'https://www.reddit.com/r/MechanicalKeyboards/comments/1abc234/comment/klm123/',
            createdUtc: 1_718_201_500,
          },
        ],
      },
    },
    'subreddit-details': {
      description:
        'Subreddit metadata: weekly active users, description, category and icon.',
      input: { subreddit: 'MechanicalKeyboards' },
      sample: {
        id: 't5_2qh1e',
        name: 'MechanicalKeyboards',
        weeklyActiveUsers: 184_000,
        description: 'Keyboard lovers, unite. Show off your builds and ask for help.',
        advertiserCategory: 'Technology',
        iconUrl: 'https://styles.redditmedia.com/mechanicalkeyboards/icon.png',
        createdUtc: 1_334_707_200,
      },
    },
    'post-transcript': {
      description:
        'Spoken transcript from a Reddit video post by URL, with the detected language.',
      input: { url: 'https://www.reddit.com/r/MechanicalKeyboards/comments/1def567/' },
      sample: {
        postId: 't3_1def567',
        language: 'en',
        transcript: 'Here is my first ever custom build, lubed switches and a brass plate.',
        transcriptNotAvailable: false,
      },
    },
  },
});
